export const Urls = {
    GetAttachments: "RightShipAttachment/getAttachments",
    GetSharedAccessSignatureToken: "RightShipAttachment/GetSharedAccessSignatureToken",
    GetSharedAccessSignatureTokenFromPath: "RightShipAttachment/GetSharedAccessSignatureTokenFromPath",
    GetEntityAttachmentUrl: "RightShipAttachment/GetEntityAttachmentUrl",
    SaveAttachments: "RightShipAttachment",
    DeleteAttachments: "RightShipAttachment/rsdelete",
    DeleteCorrespondenceAttachments: "RightShipAttachment/rsDeleteCorrespondence",
    UpdateAttachments: "RightShipAttachment/UpdateAttachments",
    GetDocumentsCountForEntity: "RightShipAttachment/GetDocumentsCountForEntity",
    GetAttachmentTypes: "RightShipAttachment/GetAttachmentTypes"
};
